@let size = data.size;
@let contactPhone =
  driver()?.driverData?.workPhone ?? driver()?.driverData?.privatePhone;

<onyx-modal
  variant="right"
  [size]="size"
  [heading]="driver() ? (driver()!.driverData | onyxName) : undefined"
  [loading]="loading()"
  [(error)]="error"
  [close$]="close$"
  (errorChange)="driver$.next()"
  (closeModal)="dialogRef.close()"
>
  <ng-container titleLeftOptions>
    @if (driver()) {
      <onyx-icon
        [name]="driverIcon().icon"
        [onyxTooltip]="driverIcon().tooltip"
        onyxTooltipColor="white"
        [size]="20"
      ></onyx-icon>
    }
  </ng-container>

  <ng-container titleRightOptions>
    @if (driver(); as driver) {
      <app-unavailability-icon
        [unavailability]="driver.unavailability"
      ></app-unavailability-icon>
    }
  </ng-container>

  <ng-container description>
    @if (driver(); as driver) {
      <app-driver-modal-header-description
        [driver]="driver"
      ></app-driver-modal-header-description>
    }
  </ng-container>

  <ng-container headingButtons>
    <onyx-icon-button
      variant="transparent"
      color="gray"
      [size]="32"
      icon="map-view-outlined"
      [circle]="true"
      onyxTooltip="labels.showOnMap"
      (click)="showOnMap()"
    ></onyx-icon-button>

    @if (driver(); as driver) {
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="gantt-outlined"
        [circle]="true"
        onyxTooltip="labels.showOnGantt"
        (click)="showOnGantt()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="share-outlined"
        [circle]="true"
        onyxTooltip="labels.share"
        (click)="share()"
      ></onyx-icon-button>

      @if (contactPhone; as phone) {
        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="32"
          icon="telephone-outlined"
          [circle]="true"
          onyxTooltip="labels.call"
          (click)="ActionHelper.makeCall(phone)"
        ></onyx-icon-button>
      }
    }

    <onyx-icon-button
      variant="transparent"
      color="gray"
      [size]="32"
      icon="options-vertical-filled"
      [circle]="true"
      [onyxDropdownOptions]="options()"
      [onyxDropdownDisabled]="!options()?.length"
      onyxDropdownMaxHeight="fill"
      (onyxDropdownSelectedValueChange)="$event.value?.()"
      onyxTooltip="labels.options"
      (click)="$event.stopPropagation()"
    ></onyx-icon-button>
  </ng-container>

  @if (driver(); as driver) {
    <div class="container size-{{ size }}">
      <div class="chips">
        <onyx-chips
          [chips]="sections()"
          variant="tertiary"
          [single]="true"
          [wrap]="true"
          [gap]="8"
          [(activeValues)]="section"
        ></onyx-chips>
      </div>

      @switch (section()[0]) {
        @case (DriverModalSection.SUMMARY) {
          <app-driver-modal-summary
            [driver]="driver"
            [vehicle]="vehicle()"
            [(vehicleError)]="vehicleError"
            [vehicleLoading]="vehicleLoading()"
            [close$]="close$"
            (reloadVehicle)="vehicle$.next()"
          ></app-driver-modal-summary>
        }
        @case (DriverModalSection.UNAVAILABILITIES) {
          <app-unavailabilities [driver]="driver"></app-unavailabilities>
        }
        @case (DriverModalSection.DETAILS) {
          <app-driver-modal-details
            [driver]="driver"
            [size]="informationRowSize()"
          ></app-driver-modal-details>
        }
        @case (DriverModalSection.DOCUMENTS) {
          <app-driver-modal-documents
            [driver]="driver"
            [size]="informationRowSize()"
          ></app-driver-modal-documents>
        }
        @case (DriverModalSection.NOTE) {
          <app-modal-note
            heading="labels.note"
            [note]="driver.note"
            [route]="DriversRoute.EDIT_DRIVER.replace(':uuid', driver.uuid)"
            [close$]="close$"
          ></app-modal-note>
        }
      }
    </div>
  }
</onyx-modal>
